module.exports = __webpack_public_path__ + "static/media/myWallet.9e58e034.svg";